/**
 * Review API — the staged-extraction gate at /api/finance/review.
 *
 * Rows land here when LLM extraction confidence fell below the automation
 * policy threshold. Every decision (accept / correct / reject) is published
 * by the backend to the lake as training signal — reviewing is not just
 * cleanup, it makes the extractors better.
 */

import {
  apiClient,
  buildQueryString,
  type PaginatedResponse,
} from "@/shared/lib/api/client";
import type {
  ReviewCorrection,
  ReviewDecision,
  Transaction,
} from "../types";

const BASE = "/api/finance/review";

export function listReviewQueue(params?: {
  skip?: number;
  limit?: number;
}): Promise<PaginatedResponse<Transaction>> {
  const qs = buildQueryString({
    skip: params?.skip ?? 0,
    limit: params?.limit ?? 50,
  });
  return apiClient<PaginatedResponse<Transaction>>(`${BASE}${qs}`);
}

export function acceptReview(transactionId: string): Promise<ReviewDecision> {
  return apiClient<ReviewDecision>(`${BASE}/${transactionId}/accept`, {
    method: "POST",
  });
}

export function correctReview(
  transactionId: string,
  correction: ReviewCorrection,
): Promise<ReviewDecision> {
  return apiClient<ReviewDecision>(`${BASE}/${transactionId}/correct`, {
    method: "POST",
    body: JSON.stringify(correction),
  });
}

export function rejectReview(transactionId: string): Promise<ReviewDecision> {
  return apiClient<ReviewDecision>(`${BASE}/${transactionId}/reject`, {
    method: "POST",
  });
}
